import { render, staticRenderFns } from "./addCapacity.vue?vue&type=template&id=6433717b&scoped=true&"
import script from "./addCapacity.vue?vue&type=script&lang=js&"
export * from "./addCapacity.vue?vue&type=script&lang=js&"
import style0 from "./addCapacity.vue?vue&type=style&index=0&id=6433717b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6433717b",
  null
  
)

export default component.exports